import { FlexibilityPage } from '@features/flexibility/components/FlexibilityPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/recurring')({ component: FlexibilityPage });
